var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M7 1.90735e-06L2.2891 5.98417L7 12L4.81043 12L4.90832e-08 5.98417L4.81043 1.71593e-06L7 1.90735e-06Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }